import { z } from "zod";
import i18n from "@/bootstrap/translations";

const email = z
	.string()
	.email(i18n.t("shared.forms.validation.invalid", { field: i18n.t("shared.forms.email.label") }));

const password = z
	.string()
	.min(6, i18n.t("shared.forms.validation.min", { field: i18n.t("shared.forms.password.label"), min: 6 }))
	.max(128, i18n.t("shared.forms.validation.max", { field: i18n.t("shared.forms.password.label"), max: 128 }));

/**
 * passwordWithRules Validator (For Registration, Reset, etc.)
 * - Enforces lowercase, uppercase, number, special character.
 */
export const passwordWithRules = password
	.regex(/[a-z]/, i18n.t("shared.forms.validation.lowercase", { field: i18n.t("shared.forms.email.label") }))
	.regex(/[A-Z]/, i18n.t("shared.forms.validation.uppercase", { field: i18n.t("shared.forms.email.label") }))
	.regex(/[0-9]/, i18n.t("shared.forms.validation.number", { field: i18n.t("shared.forms.email.label") }))
	.regex(/[\W_]/, i18n.t("shared.forms.validation.special_character", { field: i18n.t("shared.forms.email.label") }));

const numberField = (limits?: { min?: number | null; max?: number | null }) =>
	z
		.string()
		.trim()
		.min(1, "This field is required")
		.refine(value => Number.isFinite(Number(value)), "Enter a valid number")
		.refine(value => limits?.min == null || Number(value) >= limits.min, {
			message: `Must be at least ${limits?.min}`,
		})
		.refine(value => limits?.max == null || Number(value) <= limits.max, {
			message: `Must be at most ${limits?.max}`,
		});

export const validation = {
	password,
	passwordWithRules,
	email,
	numberField,
};
